@if (!isLoadingTree) {
    <div class="d-flex mb-3 align-items-center">
        <div class="input-group me-2">
            <input
                [formControl]="dataslagSearch"
                type="search"
                class="form-control"
                placeholder="{{ lang.GetValue('Layerlist.SearchLayer') }}"
                aria-label="Sök lager"
                aria-describedby="button-addon2"
            />

            <button class="btn btn-primary search-btn" type="button" id="button-addon2">
                <app-svg-icon [svgIcon]="searchIcon"></app-svg-icon>
                <span class="visually-hidden">Sök</span>
            </button>
        </div>

        <div class="form-check show_choosen_checkbox_container">
            <input type="checkbox" class="form-check-input" [formControl]="showChoosenDataslag" id="showChoosenDataslag" />
            <label
                class="form-check-label"
                for="showChoosenDataslag"
                [trvTooltip]="
                    numberOfDataProdukterActive() +
                    ' ' +
                    (numberOfDataProdukterActive() === 1 ? lang.GetValue('Layerlist.ShowChoosen') : lang.GetValue('Layerlist.ShowChoosenPlural'))
                "
            >
                {{ lang.GetValue('MapMenu.Selected') }}
            </label>
        </div>
        <button type="button" class="p-2 btn-close" aria-label="Close" [trvTooltip]="'Släck alla lager'" (click)="disableAllLayers()"></button>
    </div>
    @if (hasAnyVisibleDataProducts()) {
        <div class="c-datatypes" style="position: relative; left: -10px">
            <cdk-tree [dataSource]="dataSource" [treeControl]="treeControl" class="trv-tree">
                <cdk-nested-tree-node
                    *cdkTreeNodeDef="let node; when: hasChild"
                    class="trv-tree__group"
                    [class.is-open]="treeControl.isExpanded(node)"
                    [class.d-none]="shouldHideNode(node)"
                >
                    <div class="trv-tree__node" role="treeitem" [attr.aria-expanded]="treeControl.isExpanded(node)" [attr.aria-level]="node.level">
                        @if (node.children?.length > 0) {
                            <button class="btn btn-node-toggle" [attr.aria-label]="'Toggle ' + node.name" cdkTreeNodeToggle>
                                @if (!treeControl.isExpanded(node)) {
                                    <fa-icon [icon]="faAngleRight"></fa-icon>
                                }
                                @if (treeControl.isExpanded(node)) {
                                    <fa-icon [icon]="faAngleDown"></fa-icon>
                                }
                            </button>
                        }
                        <div class="trv-tree__content w-100" [style.padding-left]="node.level * 55 + 'px'">
                            <div class="form-check c-datatypes__datatype dataslag-item w-100">
                                <input
                                    type="checkbox"
                                    [attr.id]="'node-separate-' + node.id"
                                    class="form-check-input"
                                    [(ngModel)]="node.selected"
                                    (ngModelChange)="onNodeSelected(node, '')"
                                />
                                <label [attr.for]="'node-separate-' + node.id" class="form-check-label no-select w-100">
                                    @if (node.layer != undefined) {
                                        <span class="layerName">{{ getDisplayName(node.layer) }}</span>
                                    } @else {
                                        <span class="headlineName">{{ lang.GetValue(node.name) }}</span>
                                    }
                                </label>

                                <div class="c-datatypes__handle">
                                    @if (node.layer != undefined) {
                                        @if (node.layer.type == 'wms' && node.layer.getCapabilitiesStatus) {
                                            @if (!(node.layer.getCapabilitiesStatus == 'Done' || node.layer.getCapabilitiesStatus == 'Error')) {
                                                <button
                                                    class="btn btn-outline-secondary c-datatypes__btn"
                                                    [trvTooltip]="'Lagerinformation laddas'"
                                                    [position]="toolTipPositions"
                                                    [trv-loading]="true"
                                                >
                                                    <span class="visually-hidden fix">Lagerinformation laddas</span>
                                                </button>
                                            }

                                            @if (node.layer.getCapabilitiesStatus == 'Error') {
                                                <button
                                                    class="btn btn-outline-secondary c-datatypes__btn bug"
                                                    [trvTooltip]="'Ett fel skedde vid hämtning av lagerdata'"
                                                    [position]="toolTipPositions"
                                                >
                                                    <app-svg-icon [svgIcon]="svgWarning"></app-svg-icon>
                                                    <span class="visually-hidden fix">Lagerinformation laddas</span>
                                                </button>
                                            }
                                        }

                                        @if (trvMapService.trvMap?.needToZoomInOnLayer(node.layer)) {
                                            <button class="btn btn-outline-secondary c-datatypes__btn">
                                                <app-svg-icon [svgIcon]="searchIconPlusFilled"></app-svg-icon>
                                            </button>
                                        }

                                        <button class="btn btn-outline-secondary c-datatypes__btn" (click)="infoAboutLayer(node.layer)">
                                            <app-svg-icon [svgIcon]="infoIcon"></app-svg-icon>
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    @if (treeControl.isExpanded(node)) {
                        <ng-container cdkTreeNodeOutlet></ng-container>
                    }
                </cdk-nested-tree-node>
            </cdk-tree>
        </div>
    } @else {
        <div>Inga lager hittades.</div>
    }
} @else {
    <div [trv-loading]="true">Laddar lager</div>
}
